<template>
  <div>
    <div class="teacher_achievement_wrap" v-if="!isShowDetails">
      <div class="teacher_achievement_title">
        <!-- <h2>学员列表 </h2> -->

        <h2>
          考核标准
          <span>计分规则：总成绩（100分） = 课件学习（{{headData.coursewareRate}}%）+单元测验（{{headData.unitExamRate}}%）+课程考试（{{headData.courseExamRate}}%）+考勤出勤率（{{headData.attendanceExamRate}}%）</span>
        </h2>
        <el-input
          v-model="searchName"
          placeholder="请输入学生姓名"
          type="text"
          autocomplete="off"
          prefix-icon="el-icon-user"
        ></el-input>
        <el-button @click="searchFn">查询</el-button>
        <el-button @click="clickUpdate">更新</el-button>
        
      </div>
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :header-cell-style="{background:'rgba(83,151,247,0.1)',color:'#999'}"
        :height="pageTotal.total>10?(height+20):(height+60)"
        class="teacher_achievement_table"
      >
        <el-table-column label="姓名" prop="name" show-overflow-tooltip></el-table-column>
        <el-table-column label="学号" prop="studentNumber"></el-table-column>
        <el-table-column label="学习课件成绩" prop="coursewareScore"></el-table-column>
        <el-table-column label="单元测验成绩" prop="unitExamScore"></el-table-column>
        <el-table-column label="课程考试成绩" prop="courseExamScore"></el-table-column>
        <el-table-column label="考勤成绩" prop="attendanceScore"></el-table-column>
        <el-table-column label="当前总成绩" prop="sumScore"></el-table-column>
        <el-table-column fixed="right" label="操作" width="240">
          <template slot-scope="scope">
            <el-button @click.native.prevent="seeRow(scope.row)" round size="small">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
       <el-pagination
          v-if="pageTotal.total>10"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageTotal.currentPage"
          background
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageTotal.pageSize"
          :pager-count="5"
          layout="sizes, prev, pager, next"
          :total="pageTotal.total"
          class="paginator"
        ></el-pagination>
    </div>
    <div class="student_details_wrap" v-else>
      <div class="student_details_title">
        <h2>{{scoreData.studentName}} 《{{scoreData.courseName}}》 的分数明细</h2>
        <p>计分规则：总成绩（100分） = 课件学习（{{scoreData.coursewareRate}}）+单元测验（{{scoreData.unitExamRate}}）+课程考试（{{scoreData.courseExamRate}}）+考勤出勤率（{{scoreData.attendanceExamRate}}）</p>
        <el-button @click="isShowDetails=false" class="back_notice_list">返回</el-button>
      </div>
      <div class="student_details_scoring">
        <div>
          <b>{{scoreData.sumScore}}</b>
          <strong>分</strong>
          <span>当前课程总得分</span>
        </div>
        <span>=</span>
        <div>
          <b>{{scoreData.coursewareScore}}</b>
          <strong>分</strong>
          <span>课件学习</span>
        </div>
        <span>+</span>
        <div>
          <b>{{scoreData.unitExamScore}}</b>
          <strong>分</strong>
          <span>单元测验</span>
        </div>
        <span>+</span>
        <div>
          <b>{{scoreData.courseExamScore}}</b>
          <strong>分</strong>
          <span>课程考试</span>
        </div>
         <span>+</span>
        <div>
          <b>{{scoreData.attendanceExamScore}}</b>
          <strong>分</strong>
          <span>考勤分数</span>
        </div>
      </div>
      <div class="student_details_tab">
        <el-tabs v-model="activeName">
          <el-tab-pane label="课件学习" name="first">
            <CoursewareLearning
              :courseId="courseId"
              :classId="classId"
              :userId="userId"
              v-if="activeName=='first'"
            ></CoursewareLearning>
          </el-tab-pane>
          <el-tab-pane label="单元测验" name="second">
            <UnitTest
              :courseId="courseId"
              :classId="classId"
              :userId="userId"
              v-if="activeName=='second'"
            ></UnitTest>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import Pagination from "../../../../../paginator/paginator";
import CoursewareLearning from "./coursewareLearning";
import UnitTest from "./unitTest";
import * as api from "../../../../../../api/achievementApi";
export default {
  components: {
    Pagination,
    CoursewareLearning,
    UnitTest
  },
  data() {
    return {
      // courseId: 989, //这个是测试数据 因为我暂时无法添加数据
      // userId: 59500,
      // classId: 1482,
      courseId: this.$route.query.id,
      userId: '',
      classId:this.$route.query.classId,
      searchName: "",
      tableData: [],
      height: window.innerHeight - 200, // 表格高度根据窗口高度来决定
      pageTotal: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      activeName: "first",
      isShowDetails: false,
      scoreData: {
        studentName: "",
        courseName: "",
        sumScore: "",
        coursewareScore: "",
        coursewareRate: "",
        unitExamScore: "",
        unitExamRate: "",
        courseExamScore: "",
        courseExamRate: "",
        attendanceExamRate: '',
        attendanceExamScore: '',
      },
      headData: {
        attendanceExamRate: 20,
        courseExamRate: 40,
        coursewareRate: 30,
        unitExamRate: 10
      }
    };
  },
  mounted() {
    this.getTableList();
  },
  methods: {
    getTableList(val) {
      console.log(val)
      let data = {
        courseId: this.courseId,
        classId: this.classId,
        queryParam: this.searchName,
        pageNo: val||this.pageTotal.currentPage,
      	pageSize: this.pageTotal.pageSize
      };
      api.getAchievementList(data).then(rs => {
        
        if (rs.code == 0) {
          this.tableData = rs.data.pageInfo.list;
          // this.pageTotal = {
          //   currentPage: rs.data.data.pageNum,
          //   pageSize: rs.data.data.pageSize,
          //   total: rs.data.data.total
          // }
          this.pageTotal.total=rs.data.pageInfo.total;
          this.headData=rs.data;
        } else {
          this.$messageError(rs.msg);
        }
      });
    },
    clickUpdate(){
        let data = {
        	classId: this.classId,
        	courseId: this.courseId
        }
        api.clickUpdata(data).then(rs=>{
           if (rs.code == 0) {
              this.getTableList();
                this.$message({
                  type: "success",
                  message: "更新成功!"
                });
              } else {
                this.$message.error("更新失败");
              }
        })
    },
    searchFn() {
      
      console.log(this.pageTotal.currentPage)
      
      this.pageTotal.currentPage=1;

      console.log(this.pageTotal.currentPage)
      this.getTableList();
    },
    seeRow(row) {
      console.log(row.userId);
      //因zyp账号没数据 这里暂且用死id
      this.userId = row.userId;
      // this.userId = 59500
      this.isShowDetails = true;
      this.getData(row.userId, this.courseId);
    },
    getData(userId, courseId) {
      let obj = {
        courseId: courseId,
        userId: userId,
        classId: this.classId
      };
      api.getAchievementCourseHead(obj).then(rs => {
        if (rs.code == 0) {
          this.scoreData = {
            studentName: rs.data.name,
            courseName: rs.data.courseName,
            sumScore: Number(rs.data.sumScore)
              ? Number(rs.data.sumScore)
              : rs.data.sumScore,
            coursewareScore: Number(rs.data.coursewareScore),
            coursewareRate:
              rs.data.coursewareRate || rs.data.coursewareRate == 0
                ? rs.data.coursewareRate + "%"
                : "无",
            unitExamScore: Number(rs.data.unitExamScore),
            unitExamRate:
              rs.data.unitExamRate || rs.data.unitExamRate == 0
                ? rs.data.unitExamRate + "%"
                : "无",
            courseExamScore: Number(rs.data.courseExamScore),
            courseExamRate:
              rs.data.courseExamRate || rs.data.courseExamRate == 0
                ? rs.data.courseExamRate + "%"
                : "无",
            attendanceExamScore: Number(rs.data.attendanceExamScore),
            attendanceExamRate:
              rs.data.attendanceExamRate || rs.data.attendanceExamRate == 0
                ? rs.data.attendanceExamRate + "%"
                : "无",
            showFlag: rs.data.showFlag
          };
        } else {
          this.$messageError(rs.msg);
        }
      });
    },
     handleCurrentChange(val){
      //  console.log(val)
      this.pageTotal.currentPage = val;
      // console.log(11111111111111)
      this.getTableList(val);
    },
    handleSizeChange(val) {
      console.log(val)
      this.pageTotal.pageSize = val;
      this.pageTotal.currentPage = 1;
      this.handleCurrentChange(1)
      console.log(111111)
    },
  }
};
</script>
<style lang="scss">
.teacher_achievement_wrap {
  background: #fff;
  padding: 0 24px;
  box-sizing: border-box;
  .teacher_achievement_title {
    height: 50px;
    h2 {
      width: calc(100% - 400px);
      display: inline-block;
      line-height: 50px;
      font-size: 16px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      span {
        font-size: 12px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin-left: 16px;
      }
    }
    .el-input {
      display: inline-block;
      width: 240px;
      .el-input__inner {
        height: 30px;
        line-height: 30px;
      }
      .el-input__icon {
        line-height: 30px;
      }
    }
    button {
      padding: 7px 18px;
      font-size: 12px;
      color: #5397f7;
      border-color: #5397f7;
      margin-left: 10px;
    }
  }
  .teacher_achievement_table {
    border: 1px solid #e8e8e8;
    .el-button {
      width: 56px;
      height: 24px;
      border: 1px solid rgba(228, 232, 241, 1);
      border-radius: 12px;
      font-size: 10px;
      font-weight: 400;
      color: rgba(83, 151, 247, 1);
      padding: 0;
    }
    .el-table__empty-text{
      margin-top: 20%;
    }
    .el-table__empty-block{
      background: url("../../../../../../../static/images/wujieguo.png") no-repeat 50% 50%;
    }
  }
}
.student_details_wrap {
  background: #fff;
  margin: 0 10px;
  padding: 0 24px;
  box-sizing: border-box;
  .student_details_title {
    display: flex;
    height: 50px;
    align-items: center;
    position: relative;
    h2 {
      font-size: 16px;
      line-height: 21px;
      color: rgba(51, 51, 51, 1);
    }
    p {
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      color: rgba(51, 51, 51, 1);
      margin-left: 24px;
    }
    .back_notice_list {
      position: absolute;
      padding: 6px 10px;
      right: 20px;
      top: 8px;
    }
  }
  .student_details_scoring {
    width: 100%;
    height: 88px;
    background: rgba(233, 241, 253, 1);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 0 50px;
    box-sizing: border-box;
    div {
      width: 160px;
      height: 48px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.14);
      border-radius: 4px;
      color: #333;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      &:first-child {
        width: 200px;
        height: 48px;
        background: rgba(52, 211, 176, 1);
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.14);
        border-radius: 4px;
        color: #fff;
        b {
          color: #fff;
        }
        strong {
          color: #fff;
        }
        span {
          color: #fff;
          &::after {
            background: #fff;
          }
        }
      }
      b {
        font-size: 28px;
        font-weight: 400;
      }
      strong {
        font-size: 12px;
        margin: 0 5px;
      }
      span {
        font-size: 12px;
        font-weight: 400;
        color: #333;
        position: relative;
        margin-left: 20px;
        &::after {
          content: "";
          width: 1px;
          height: 10px;
          background: #333;
          position: absolute;
          left: -10px;
          top: 2px;
        }
      }
    }
    .relearning {
      width: 124px;
      height: 40px;
      background: rgba(83, 151, 247, 1);
      border-radius: 4px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/achievement/teacher/index.vue